<template>
    <b-modal
        ref="show-question-modal"
        :title="$t('question.details.label.modal')"
        :cancel-title="$t('btn.close')"
        ok-only
        size="xl"
    >
      <div v-if="question" class="question-details">
        <h4>{{ $t('question.details.title.basic_data') }}</h4>
        <div class="row">
          <div class="col-6">
            <table class="table">
              <tr>
                <th>{{ $t('question.details.label.type') }}</th>
                <td>{{ $t('question_type_'+question.type) }}</td>
              </tr>
              <tr>
                <th>{{ $t('question.details.label.difficult_level') }}</th>
                <td v-if="question.difficultyLevel == 1">{{ $t('question.easy') }}</td>
                <td v-if="question.difficultyLevel == 2">{{ $t('question.medium') }}</td>
                <td v-if="question.difficultyLevel == 3">{{ $t('question.difficult') }}</td>
                <td v-if="question.difficultyLevel == 4">{{ $t('question.very_difficult') }}</td>
              </tr>
              <tr>
                <th>{{ $t('question.details.label.categories') }}</th>
                <td>
                  <div v-for="(category, index) in question.categories" :key="index">
                    {{ $t('category.'+category.name) }}
                    <span v-if="index < question.categories.length - 1">, </span>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ $t('question.details.label.question_status') }}</th>
                <td :class="[question.status === '10' ? 'text-secondary' : 'text-success']">{{ $t('question_status_'+ question.status )}}</td>
              </tr>
              <tr>
                <th>{{ $t('question.details.label.correct_answer') }}</th>
                <td>{{ question.correctAnswer }}</td>
              </tr>
              <tr v-if="question.type !== 'text'">
                <th>{{ $t('question.details.label.media_url') }}</th>
                <td>
                  <a v-if="question.mediaUrl" :href="question.mediaUrl" target="_blank" class="ml-2">
                    {{ $t('question.details.link.question_file') }}
                  </a>
                  <span v-else>{{ $t('question.details.file_not_exists') }}</span>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-6">
            <table class="table">
              <tr>
                <th>{{ $t('question.details.label.question_id') }}</th>
                <td>{{ question.id }}</td>
              </tr>
              <tr>
                <th>{{ $t('question.details.label.created_at') }}</th>
                <td>{{ questionCreatedAt }}</td>
              </tr>
              <tr>
                <th>{{ $t('question.details.label.updated_at') }}</th>
                <td>{{ questionUpdatedAt }}</td>
              </tr>
            </table>
          </div>
        </div>
        <h4>{{ $t('question.details.title.content') }}</h4>
        <div class="translation-container" v-for="(translation, index) in question.contentTranslations" :key="index">
          <div class="row">
            <div class="col-6">
              <table class="table">
                <tr>
                  <th>{{ $t('question.details.label.language') }}</th>
                  <td><img :src="`~@/assets/flags/${translation.locale}.svg`" style="width: 20px;" class="table-flags"> {{ translation.locale.toUpperCase() }}</td>
                </tr>
                <tr>
                  <th>{{ $t('question.details.label.question') }}</th>
                  <td>{{ translation.question }}</td>
                </tr>
              </table>
            </div>
            <div class="col-6">
              <table class="table">
                <tr v-for="(value, name) in translation.answers" :key="name">
                  <th>{{ $t('question.details.label.answer') }} {{ name }}:</th>
                  <td>{{ value }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  data() {
    return {
        question: null,
        questionCreatedAt: null,
        questionUpdatedAt: null
      }
  },
  filters: {},
  mounted() {

  },
  methods: {
    openModal(item) {
      this.getQuestionDetails(item);
      this.$refs['show-question-modal'].show()
    },
    getQuestionDetails(item) {
      axios.get(`/api/question/question/${item.id}`)
        .then(resp => {
          this.question = resp.data;
          this.questionCreatedAt = moment(this.question.createdAt).format('YYYY-MM-DD, h:mm:ss a');
          this.questionUpdatedAt = moment(this.question.updatedAt).format('YYYY-MM-DD, h:mm:ss a');
        });
    }
  }
}
</script>
